(function () {
  'use strict';
  if (window.pcCartIncentivesLoaded) return;
  window.pcCartIncentivesLoaded = true;

  var storageKey = 'armazens-auroraCartReservationDeadline';
  var busy = false;
  var protectionHandle = 'protecao-de-envio';

  function isProtectionItem(item) {
    return item && (
      item.handle === protectionHandle ||
      Array.from(document.querySelectorAll('[data-pc-shipping-protection]')).some(function (el) { return Number(el.dataset.productId) === Number(item.product_id); }) ||
      (item.properties && item.properties._armazens_aurora_shipping_protection === 'true')
    );
  }

  function updateVisibleCartCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var visibleCount = cart.items.reduce(function (total, item) {
      return isProtectionItem(item) ? total : total + (Number(item.quantity) || 0);
    }, 0);
    var displayCount = visibleCount > 99 ? '99+' : String(visibleCount);

    document.querySelectorAll('[data-cart-count]').forEach(function (wrapper) {
      wrapper.setAttribute('data-cart-count', String(visibleCount));
    });
    document.querySelectorAll('.js-header-cart-item-count').forEach(function (output) {
      output.textContent = displayCount;
    });
  }

  function removeProtectionFromStorefront(root) {
    var scope = root && root.querySelectorAll ? root : document;
	var directMarker = scope.matches && scope.matches('[data-pc-hidden-protection-product]') ? scope : null;
	if (directMarker) {
		var directContainer = directMarker.closest(
			'.collection__item, .search__item, .product-recommendations__col, .complementary-products__slider-slide, .featured-products__item'
		);
		if (directContainer) directContainer.remove();
	}

    scope.querySelectorAll('[data-pc-hidden-protection-product]').forEach(function (marker) {
      var container = marker.closest(
        '.collection__item, .search__item, .product-recommendations__col, .complementary-products__slider-slide, .featured-products__item'
      );
      if (container) {
        container.remove();
      } else {
        marker.remove();
      }
    });

    scope.querySelectorAll('a[href*="/products/' + protectionHandle + '"]').forEach(function (link) {
      var result = link.closest(
        '.predictive-search__result-col, .search__item, .product-recommendations__col, .complementary-products__slider-slide, .product-card, .product-card-new, .compare-product-card'
      );
      if (result) result.remove();
    });
  }

  function registerCartCountCorrection() {
    if (!window.themeCore || !window.themeCore.EventBus) {
      window.setTimeout(registerCartCountCorrection, 100);
      return;
    }

    window.themeCore.EventBus.listen(['cart:updated', 'header:update-item-count'], function (cart) {
      if (cart && Array.isArray(cart.items)) {
        updateVisibleCartCount(cart);
        scheduleProtectionSync();
      } else {
        window.setTimeout(syncVisibleCartCount, 0);
        scheduleProtectionSync();
      }
    });
  }

  function syncVisibleCartCount() {
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(updateVisibleCartCount)
      .catch(function () {});
  }

  function getDeadline(timer) {
    var minutes = parseInt(timer.getAttribute('data-duration-minutes'), 10) || 10;
    var stored = parseInt(sessionStorage.getItem(storageKey), 10);

    if (!stored || stored <= Date.now()) {
      stored = Date.now() + (minutes * 60 * 1000);
      sessionStorage.setItem(storageKey, String(stored));
    }

    return stored;
  }

  function updateTimers() {
    var drawer = document.getElementById('CartDrawer');

    if (drawer && drawer.classList.contains('is-empty')) {
      sessionStorage.removeItem(storageKey);
      return;
    }

    document.querySelectorAll('[data-pc-cart-timer]').forEach(function (timer) {
      var output = timer.querySelector('[data-pc-cart-timer-value]');
      if (!output) return;

      var remaining = Math.max(0, getDeadline(timer) - Date.now());
      var totalSeconds = Math.ceil(remaining / 1000);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      output.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
    });
  }

  var protectionState = null;
  var syncTimer;
  var lockedButtons = new Map();
  async function protectionRequest(path, body) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    var data = await response.json();
    if (!response.ok) throw Error(typeof data.description === 'string' ? data.description : 'Não foi possível atualizar a proteção de envio. Tente novamente.');
    return data;
  }
  function paintProtection(cart) {
    protectionState = cart;
    var services = cart.items.filter(isProtectionItem);
    var hasMerchandise = cart.items.some(function (item) { return !isProtectionItem(item); });
    document.querySelectorAll('[data-pc-shipping-protection]').forEach(function (root) {
      root.hidden = !hasMerchandise && root.dataset.designMode !== 'true';
      var toggle = root.querySelector('[data-pc-protection-toggle]');
      toggle.checked = services.length > 0;
      toggle.disabled = busy || (!services.length && toggle.dataset.available !== 'true');
      root.querySelector('[data-pc-protection-unavailable]').hidden = services.length > 0 || toggle.dataset.available === 'true';
    });
    updateVisibleCartCount(cart);
  }
  function lockProtection(value) {
    busy = value;
    if (value) document.querySelectorAll('[name="checkout"], .js-cart-footer-checkout').forEach(function (button) {
      lockedButtons.set(button, button.disabled); button.disabled = true;
    });
    else { lockedButtons.forEach(function (disabled, button) { if (button.isConnected) button.disabled = disabled; }); lockedButtons.clear(); }
    if (protectionState) paintProtection(protectionState);
  }
  function refreshProtectionSections(cart) {
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.cartObject = cart;
      window.themeCore.EventBus.emit('cart:refresh');
      window.themeCore.EventBus.emit('header:update-item-count', cart);
    }
  }
  async function normalizeProtection(cart, enabled) {
    var services = cart.items.filter(isProtectionItem);
    var hasMerchandise = cart.items.some(function (item) { return !isProtectionItem(item); });
    var updates = {};
    services.forEach(function (item, index) {
      var quantity = hasMerchandise && enabled && index === 0 ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    return Object.keys(updates).length ? protectionRequest('cart/update.js', { updates: updates }) : cart;
  }
  async function syncProtection() {
    if (busy) { scheduleProtectionSync(); return; }
    lockProtection(true);
    try {
      var cart = await protectionRequest('cart.js');
      var updated = await normalizeProtection(cart, true);
      paintProtection(updated);
      if (updated !== cart) refreshProtectionSections(updated);
    } catch (error) { /* A later cart event retries synchronization. */ }
    finally { lockProtection(false); }
  }
  function scheduleProtectionSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncProtection, 100);
  }
  async function updateProtection(toggle) {
    if (busy) { if (protectionState) paintProtection(protectionState); return; }
    var enabled = toggle.checked;
    lockProtection(true);
    document.querySelectorAll('[data-pc-protection-error]').forEach(function (el) { el.textContent = ''; });
    try {
      var cart = await protectionRequest('cart.js');
      if (enabled && !cart.items.some(function (item) { return !isProtectionItem(item); })) throw Error('Adicione primeiro um produto ao carrinho.');
      if (enabled && !cart.items.some(isProtectionItem)) {
        var variant = Number(toggle.dataset.variantId);
        if (!variant || toggle.dataset.available !== 'true') throw Error('Proteção de envio temporariamente indisponível.');
        await protectionRequest('cart/add.js', { items: [{ id: variant, quantity: 1, properties: { _armazens_aurora_shipping_protection: 'true' } }] });
        cart = await protectionRequest('cart.js');
      }
      cart = await normalizeProtection(cart, enabled);
      paintProtection(cart);
      refreshProtectionSections(cart);
    } catch (error) {
      try { paintProtection(await protectionRequest('cart.js')); } catch (_) { toggle.checked = !enabled; }
      document.querySelectorAll('[data-pc-protection-error]').forEach(function (el) { el.textContent = error.message; });
    } finally { lockProtection(false); }
  }


  document.addEventListener('change', function (event) {
    var variantSelect = event.target.closest('[data-pc-upsell-variant-select]');
    if (variantSelect) {
      var form = variantSelect.closest('form');
      var input = form && form.querySelector('[data-pc-upsell-variant-input]');
      if (input) input.value = variantSelect.value;
      return;
    }

    var protectionToggle = event.target.closest('[data-pc-protection-toggle]');
    if (protectionToggle) updateProtection(protectionToggle);
  });

  var storefrontObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          removeProtectionFromStorefront(node);
          if (node.matches('[data-pc-shipping-protection]') || node.querySelector('[data-pc-shipping-protection]')) scheduleProtectionSync();
        }
      });
    });
  });

  removeProtectionFromStorefront(document);
  storefrontObserver.observe(document.documentElement, { childList: true, subtree: true });
  registerCartCountCorrection();
  syncVisibleCartCount();
  scheduleProtectionSync();
  document.addEventListener('shopify:section:load', scheduleProtectionSync);
  updateTimers();
  window.setInterval(updateTimers, 1000);
}());
